import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'
import user from './modules/user'
import calendar from './modules/calendar'
import alerts from './modules/alerts'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    user,
    calendar,
    alerts
  },
  state: {
    controls: {
      showDrawer: true
    }
  },
  mutations: {
    toggleDrawer(state, value) {
      state.controls.showDrawer = value
    }
  }
})
